import { initialStateMap } from "./initializers"
  
export default function map(state=initialStateMap, action) {

    let newState = { ...state};    

    switch (action.type) {

        case 'FETCH_GEOMETRIES':
            // console.log("Downloaded area count:", action.geometries.features.length);
            newState = {...newState, geojsoncounter: (1 + state.geojsoncounter), areaproperties: action.areaproperties, geometries: action.geometries};
            return newState;

        case 'REDRAW_GEOJSON':
            newState = {...newState, geojsoncounter: (1 + state.geojsoncounter)};
            return newState;

        default:
            return state;
    }
}
